// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","centerHeader":"styles_centerHeader__591rK","headerLogo":"styles_headerLogo__SIs9N"};